<template>
  <div>
    <loader v-if="!pageLoaded"></loader>

    <div v-else class="px-4 mt-2 mb-8">
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="5"
      >
        <v-card class="mx-2 mt-12">
          <v-card-text>
            <form
              @submit.prevent="sendInvite()"
              ref="form"
              lazy-validation
            >
              <v-text-field
                v-model="email"
                ref="email"
                label="Email"
                autofocus
                required
              ></v-text-field>

              <v-autocomplete
                v-model="awardId"
                :items="awards"
                :filter="customFilter"
                item-text="name"
                item-value="id"
                label="Award"
                clearable
              ></v-autocomplete>

              <v-textarea
                v-model="message"
                label="Message"
                placeholder="Type your message here"
                rows="4"
                class="mt-3"
                filled
              ></v-textarea>

              <v-btn
                block
                depressed
                large
                :loading="loading"
                :disabled="loading"
                type="submit"
                color="accent"
              >Send</v-btn>
            </form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import messagesMixin from '@/mixins/messagesMixin'

export default {
  name: 'Create',

  mixins: [messagesMixin],

  components: {
    Loader
  },

  data () {
    return {
      awardId: null,
      awards: [],
      email: '',
      loader: null,
      loading: false,
      message: '',
      pageLoaded: false
    }
  },

  mounted () {
    Promise.all([
      this.getAwards()
    ])
      .then(() => {
        this.pageLoaded = true
      })
  },

  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]
      this.loader = null
    }
  },

  methods: {
    customFilter (item, queryText) {
      return item.name.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    },

    getAwards () {
      return this.$http.get('/awards')
        .then(({ data }) => {
          this.awards = data.awards
        })
        .catch(error => {
          console.log(error)
        })
    },

    sendInvite () {
      this.loader = 'loading'

      this.$http.post('/users/send-invite', {
        email: this.email,
        award_id: this.awardId,
        message: this.message
      })
        .then(({ data }) => {
          this.loader = 'loading'

          this.$router.push({ name: 'users.index' })

          this.showSuccessMessage('The Invite has been sent successfully!')
        })
        .catch(error => {
          console.log(error)
          this.loader = 'loading'

          this.showErrorMessage()
        })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
